import * as React from 'react'

import { MarketedSpecialOffer } from './MarketedSpecialOffer'
import { MarketedSpecialOfferModal } from './MarketedSpecialOfferModal'
import { MarketedSpecialOfferSkeleton } from './MarketedSpecialOffer/MarketedSpecialOfferSkeleton'

export interface LandingPageLink {
  text: string
  url: string
  openExternally: boolean
  noFollow: boolean
}

export interface Images {
  largeProduct: string
}

export interface Rrp {
  displayValue: string
}

export interface FreeGiftProduct {
  images: Images[]
  title: string
  price: {
    rrp: Rrp
  }
}

export interface CloseI18nText {
  closeAriaLabel: string
  closeLabel: string
}

export interface I18nText {
  closeI18nText: CloseI18nText
  freeGiftMessage?: string
  rrpText?: string
}

export interface MarketedSpecialOfferSummaryContainerProps {
  title: string
  description?: string
  landingPageLink?: LandingPageLink
  freeGiftProduct?: FreeGiftProduct
  loading?: boolean
  i18nText: I18nText
  showIcon?: boolean
  onlyDisplayOfferBadge?: boolean
  shouldRemoveScrollLock?: boolean
  className?: string
}

export const MarketedSpecialOfferSummaryContainer = (
  props: MarketedSpecialOfferSummaryContainerProps,
) => {
  const [
    marketedSpecialOfferOpen,
    setMarketedSpecialOfferOpen,
  ] = React.useState(false)

  if (props.loading) {
    return <MarketedSpecialOfferSkeleton />
  }

  return (
    <React.Fragment>
      <MarketedSpecialOffer
        className={props.className}
        title={props.title}
        description={props.description}
        cta={
          props.landingPageLink && {
            text: props.landingPageLink.text,
            href: props.landingPageLink.url,
            openExternally: props.landingPageLink.openExternally,
            noFollow: props.landingPageLink.noFollow,
          }
        }
        freeGiftProduct={props.freeGiftProduct}
        i18nFreeGiftMessage={props.i18nText?.freeGiftMessage}
        onBadgeClick={(event) => {
          event?.stopPropagation()
          event?.preventDefault()
          setMarketedSpecialOfferOpen(true)
        }}
        direction="column"
        imageWidth={144}
        showIcon={props.showIcon}
        onlyDisplayOfferBadge={props.onlyDisplayOfferBadge}
      />

      {marketedSpecialOfferOpen && (
        <MarketedSpecialOfferModal
          title={props.title}
          description={props.description}
          cta={
            props.landingPageLink && {
              text: props.landingPageLink.text,
              href: props.landingPageLink.url,
              openExternally: props.landingPageLink.openExternally,
              noFollow: props.landingPageLink.noFollow,
            }
          }
          freeGiftProduct={props.freeGiftProduct}
          i18nText={props.i18nText}
          open={marketedSpecialOfferOpen}
          onClose={() => {
            setMarketedSpecialOfferOpen(false)
          }}
          shouldRemoveScrollLock={props.shouldRemoveScrollLock}
        />
      )}
    </React.Fragment>
  )
}
